import { ChangeDetectorRef, Component, DoCheck, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewContainerRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Select2Option } from '../../../shared/select2-option';
import { OptionData, Options } from 'select2';
import { Subject } from 'rxjs';


@Component({
    selector: 'select2',
    templateUrl: './select2.component.html',
    styleUrl: './select2.component.scss',
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => Select2Component),
        }],
    standalone: false
})


export class Select2Component implements OnInit, ControlValueAccessor, OnChanges {

  constructor(private cd: ChangeDetectorRef,private viewContainerRef: ViewContainerRef) {
    console.log(1);
  }
  ngOnChanges(changes: SimpleChanges): void {
    //if (changes.options && this.options) {
    //  setTimeout(() => {
    //    this.writeValue(this.currentValue);
    //  })
    //}
    this.initialize();

    var oldVal = this.currentValue;
    if (this.control && changes.options?.currentValue) {


      //data was emptied, so reset the selected value
      if (this.options.length == 0) {
        oldVal = null;
        this.propagateChange("");
      }


      //update the select2 control
          this.currentValue = oldVal;
          this.writeValue(this.currentValue);

    }
  }

  initialize() {

    let defaultSettings: Options = {
    };

    let settings = { defaultSettings, ...this.settings };


    if (this.control) {
      $(this.container.nativeElement).off('select2:select');
      $(this.container.nativeElement).empty().select2("destroy");
    }
    settings.data = this.options;
    this.control = $(this.container.nativeElement).select2(settings);



    this.control.on("select2:select", (e: JQuery.Event) => this.onChange(e));
  }

  onChange(e: JQuery.Event) {

    let value = this.control.val();
    this.currentValue = value;
    this.propagateChange(this.control.val());
    this.reportChanges();
  }

  reportChanges() {
    let selectedItems = $(this.container.nativeElement).select2("data");
    if (selectedItems && selectedItems.length > 0)
      this.onSelect.emit(selectedItems[0]);
    else
      this.onSelect.emit({ id: "", text: "" });

  }
  currentValue: string | number | string[];

  //below line was added for backwards compatiblity
  get value(): string | number | string[]{
    return this.currentValue;
  }
  writeValue(obj: any): void {
    this.currentValue = obj;
    setTimeout(() => {

    });
    this.control.val(obj).trigger("change");

    //    this.reportChanges();
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  @Input()
  disabled = false;

  ngOnInit(): void {
  }

  control: JQuery<HTMLElement>;

  @ViewChild("container", { static: true })
  private container: ElementRef;




  @Input()
  public options: Select2Option[];

  @Input()
  settings: Options;

  private propagateChange = (_: any) => { };
  private propagateTouch = () => { };


  @Output()
  onSelect = new EventEmitter<Select2Option>();

}
